// Phase 12 — Home Inventory route.
import * as React from 'react'; import { useQuery } from '@tanstack/react-query';
import { Card, CardContent } from '../../components/ui/Card.js';
import { SkeletonRow } from '../../components/ui/Skeleton.js';
import { EmptyState } from '../../components/ui/EmptyState.js';
import { Button } from '../../components/ui/Button.js';

export function Inventory(): JSX.Element {
  React.useEffect(() => { document.title = 'DailyDeck — Home Inventory'; }, []);
  const q = useQuery({ queryKey: ['inventory','items'], queryFn: async () => { const r = await fetch('/api/modules/inventory/items',{credentials:'same-origin'}); if(!r.ok) throw new Error('fail'); return r.json(); }, staleTime: 30_000 });

  return (
    <div className="space-y-6" data-testid="inventory-route">
      <header><h1 className="text-title-1 font-semibold text-text-primary">Home Inventory</h1><p className="text-body text-text-secondary mt-1">Track what you own, warranties, and maintenance.</p></header>
      {q.isPending && <div className="rounded-lg border border-border-subtle bg-surface-raised"><SkeletonRow/><SkeletonRow/></div>}
      {q.isError && <Card><CardContent className="py-4"><p className="text-body-strong text-text-primary">Could not load items</p><Button variant="secondary" className="mt-3" onClick={()=>void q.refetch()}>Retry</Button></CardContent></Card>}
      {q.isSuccess && q.data.length===0 && <EmptyState title="No items tracked" description="Add your first item to start tracking." />}
      {q.isSuccess && q.data.length>0 && (
        <div className="space-y-2">
          {q.data.map((i: any) => (
            <Card key={i.id}><CardContent className="flex items-start justify-between gap-4 py-4">
              <div className="min-w-0 flex-1">
                <h3 className="text-body-strong font-medium text-text-primary">{i.name}</h3>
                <div className="flex flex-wrap gap-x-3 gap-y-0.5 mt-1">
                  <span className="text-caption text-text-muted">{i.category}</span>
                  {i.purchase_date && <span className="text-caption text-text-muted">Bought: {i.purchase_date}</span>}
                  {i.warranty_expiry && <span className="text-caption text-state-warning">Warranty: {i.warranty_expiry}</span>}
                </div>
                {i.notes && <p className="text-caption text-text-secondary mt-1 line-clamp-1">{i.notes}</p>}
              </div>
              {i.maintenance_interval_days && i.last_maintenance_date && (
                <span className="text-micro text-text-muted shrink-0">Last: {i.last_maintenance_date}</span>
              )}
            </CardContent></Card>
          ))}
        </div>
      )}
    </div>
  );
}
